import React, { useEffect, useState, useRef } from "react";
import { Tooltip, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import { Box } from "components";
import { CommentIcon } from "icons";
import { convertDate, localStorageHelper } from "utils";
import { IOption } from "components/select/Select";

import { getStudentListSuccessResponse } from "redux/messagemanagement/getstudentlist/getStudentListStates";
import { searchConditionDataResponse } from "redux/messagemanagement/searchCondition/searchConditionStates";
import { temperatureListFilterDataResponse } from "redux/messagemanagement/temperaturefilterlist/temperatureFilterListStates";
// import { attendanceFilterListResponse } from "redux/messagemanagement/attendancefilterlist/attendanceFilterListStates";
import {
  FilterStudentData,
  IStudentInfo,
} from "models/messagemanagement/getStudentList";
import {
  GetStudentActionCreators,
  SearchConditionActionCreators,
} from "redux/rootActions";

// import {
//   optionFamilyIllness,
//   optionPool,
//   optionRegistrationTime,
//   optionsMarathon,
//   optionSymptoms,
// } from "./constants";
import {
  SearchConditionModalStyled,
  Wrapper,
  WrapperFields,
} from "./MessageDelivery.style";
import StudentList from "./StudentList";
import SearchCondition from "./SearchCondition";
import SendMessageModal from "./SendMessageModal";
const { useBreakpoint } = Grid;

export type FormStatus = "sendMessage" | "searchCondition" | "";
const format = "YYYY-MM-DD";

function MessageDelivery() {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "layout",
  });

  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const studentListDataResponse = useSelector(getStudentListSuccessResponse);
  const dataStatistics = undefined;

  // const attendanceFilterlistdata = useSelector(attendanceFilterListResponse);

  const currentLanguage = localStorageHelper.getItem("i18nextLng");
  const isJapanLanguage = currentLanguage === "ja";

  const scrollAbleRef = useRef<any>(undefined);
  const [isVisible, setIsVisible] = useState(false);
  const [formStatus, setFormStatus] = useState<FormStatus>();
  const [selectedRows, setSelectedRows] = useState<IStudentInfo[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [allUser, setAllUser] = useState<any[]>([]);
  const [currentPageData, setCurrentPageData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [isSelectCurrentPage, setIsSelectCurrentPage] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isSendAll, setIsSendAll] = useState(false);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [filters, setFilters] = useState<any>({
    page: 1,
    per_page: 50,
    from_date: "",
    to_date: "",
    gender: "",
  });
  const [filterActions, setFilterActions] = useState<any>({
    page: 1,
    per_page: 50,
    from_date: "",
    to_date: "",
    gender: "",
  });
  const [datas, setDatas] = useState<any>({
    genders: [],
    from_date: "",
    to_date: "",
  });

  const handleSendToAllUser = (value: boolean) => {
    setIsSendAll(value);
  };

  const showModal = (formStatus: FormStatus) => {
    setFormStatus(formStatus);
    setIsVisible(true);
  };

  const handleCancel = () => {
    setFormStatus("");
    setIsVisible(false);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setIsSelectAll(false);
    setIsSendAll(false);
    setIsSelectCurrentPage(false);
  };

  const removeEmptyValues = (object: any) => {
    const keys = Object.keys(object);
    for (let i = 0; i < keys.length; ++i) {
      const key = keys[i];
      const value = object[key];
      if (value === null || value === undefined || value === "") {
        delete object[key];
      }
    }
  };

  const renderTemperature = (temperature: any) => {
    return temperature.toFixed(1);
  };

  const returnDOB = (dob: string) => {
    if (!dob) {
      return "";
    }
    if (dob.includes("-")) {
      return dob.split("-").join("/");
    }
    return dob;
  };

  const genderGroup: any = {
    0: "男性",
    1: "女性",
    2: "回答なし",
  };

  const columns = [
    {
      title: "氏名",
      dataIndex: ["last_name", "first_name"],
      key: "first_name",
      fixed: window.innerWidth < 576 ? "" : "left",
      width: 150,
      render: (text: string, record: any) => {
        return (
          <WrapperFields>
            <div
              onClick={() => {
                showModal("sendMessage");
                setSelectedRows([
                  {
                    id: record.id,
                    name: record["last_name"] + " " + record["first_name"],
                  },
                ] as any);
                setSelectedRowKeys([record.id]);
              }}
            >
              <CommentIcon fill="#B7B7B7" />
            </div>
            <div style={{ marginLeft: 12 }}>
              {record["last_name"] + " " + record["first_name"]}
            </div>
          </WrapperFields>
        );
      },
    },
    {
      title: "性別",
      dataIndex: "gender",
      key: "gender",
      width: 98,
      render: (text: any, record: any) => {
        return <div>{genderGroup[record.gender]}</div>;
      },
    },
    {
      title: "年齢",
      dataIndex: "age",
      key: "age",
      width: isJapanLanguage ? 82 : 130,
      render: (text: any) => {
        if (!text && text !== 0) {
          return (
            <div
              style={{
                overflow: "hidden",
                width: 65,
              }}
            >
              -
            </div>
          );
        }
        return (
          <div
            style={{
              overflow: "hidden",
              width: 65,
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "生年月日",
      dataIndex: "date_of_birth",
      key: "date_of_birth",
      render: (text: any) => {
        if (!text) return;
        return <div>{returnDOB(text)}</div>;
      },
    },
  ];

  useEffect(() => {
    setCurrentPageData([]);
    // dispatch(GetDataStatisticsActionCreators.handleResetAction());
    // dispatch(SearchConditionActionCreators.searchConditionAction());

    dispatch(GetStudentActionCreators.handleResetDataAction());
  }, []);

  useEffect(() => {
    if (!studentListDataResponse) {
      setCurrentPageData([]);
      setAllUser([]);
      setTotal(0);
    }
    if (
      studentListDataResponse &&
      Object.keys(studentListDataResponse).length > 0
    ) {
      setAllUser(
        studentListDataResponse.result.filtered_patient_results.map(
          (i: any) => {
            return {
              id: i.id,
              name: i.name,
            };
          }
        )
      );
      setCurrentPageData(
        studentListDataResponse.result.patients.map((i: any) => {
          return {
            ...i,
            key: i.id,
          };
        })
      );
      setTotal(studentListDataResponse.result.total_patients);
    }
  }, [studentListDataResponse]);

  const handleSelectCurrentPage = () => {
    const rowKeys = currentPageData.map((item: any) => {
      return item.id;
    });
    const rows = currentPageData.map((item: any) => {
      return {
        id: item.id,
        name: item["last_name"] + " " + item["first_name"],
      };
    });
    setSelectedRows(rows as any);
    setSelectedRowKeys(rowKeys);
    setIsSelectCurrentPage(true);
  };

  const onSelectAllRecords = (selected: boolean) => {
    if (selected) {
      const rowKeys = allUser.map((item: any) => {
        return Number(item.id);
      });
      setSelectedRowKeys(rowKeys);
      setSelectedRows(allUser as any);
      setIsSelectAll(true);
    } else {
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setIsSelectCurrentPage(false);
    }
  };

  const handleDeselectAllRecords = () => {
    setSelectedRowKeys([]);
    setIsSelectCurrentPage(false);
    setIsSelectAll(false);
  };

  const onSelectRecord = (record: any, selected: any) => {
    let selectedRowsClone: any = [...selectedRows];
    let selectedRowKeysClone = [...selectedRowKeys];

    if (selected) {
      selectedRowsClone.push({
        id: record.id,
        name: record["last_name"] + " " + record["first_name"],
      });
      selectedRowKeysClone.push(record.id);
    }

    if (!selected && selectedRows.length) {
      selectedRowsClone = selectedRows.filter(
        (row: any) => row.id !== record.id
      );
      selectedRowKeysClone = selectedRowKeys.filter(
        (key: any) => key !== record.id
      );
    }
    if (selectedRowsClone.length === allUser.length) {
      setIsSelectAll(true);
    } else {
      setIsSelectAll(false);
    }
    setSelectedRows(selectedRowsClone);
    setSelectedRowKeys(selectedRowKeysClone);
  };

  const rowSelection = {
    preserveSelectedRowKeys: true,
    selectedRowKeys,
    onSelectAll: onSelectAllRecords,
    onSelect: onSelectRecord,
  };

  const onPageChange = (page: number) => {
    setFilterActions((prevFilter: any) => ({
      ...prevFilter,
      page,
    }));
    setFilters((prevFilter: any) => ({
      ...prevFilter,
      page,
    }));
    const params: any = {
      ...filterActions,
      page,
    };
    dispatch(GetStudentActionCreators.getStudentListAction(params));
    if (
      scrollAbleRef.current &&
      window.scrollY >= scrollAbleRef.current.offsetTop
    ) {
      window.scrollTo(0, 0);
    }
  };

  const onPerPageItemChange = (per_page: number) => {
    setFilterActions((prevFilter: any) => ({
      ...prevFilter,
      per_page,
      page: 1,
    }));
    setFilters((prevFilter: any) => ({
      ...prevFilter,
      per_page,
      page: 1,
    }));

    const params: any = {
      ...filterActions,
      per_page,
      page: 1,
    };
    dispatch(GetStudentActionCreators.getStudentListAction(params));
  };

  const handleRemoveDestination = (id: number) => {
    setSelectedRows(selectedRows.filter((row: any) => row.id !== id));
    setSelectedRowKeys(selectedRowKeys.filter((row: any) => row !== id));
  };

  const onSubmit = (data: any) => {
    const param: any = {
      ...filters,
      page: 1,
      from_date: datas.from_date,
      to_date: datas.to_date,
      gender: datas.genders?.length ? datas.genders.join() : undefined,
      user_name: filterActions.user_name || "",
    };

    removeEmptyValues(param);
    setFilters(param);
    setFilterActions(param);
    dispatch(GetStudentActionCreators.getStudentListAction(param));
    // dispatch(GetDataStatisticsActionCreators.getStatisticsAction(param));
    handleCancel();
  };

  const renderSearchCondition = () => (
    <SearchCondition
      showModal={showModal}
      onSubmit={onSubmit}
      handleSendToAllUser={handleSendToAllUser}
      datas={datas}
      setDatas={setDatas}
    />
  );

  const renderForm = () => {
    switch (formStatus) {
      case "sendMessage":
        return (
          <SendMessageModal
            isVisible={isVisible}
            isSendAll={isSendAll}
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            handleCancel={handleCancel}
            handleRemoveDestination={handleRemoveDestination}
          />
        );
      case "searchCondition":
        return (
          <SearchConditionModalStyled
            type="form"
            title={t("search-condition-setting")}
            visible={isVisible}
            onCancel={handleCancel}
          >
            {renderSearchCondition()}
          </SearchConditionModalStyled>
        );
      default:
        return;
    }
  };

  return (
    <Box title={t2("message-delivery-label")} padding="0px 16px 0px">
      {renderForm()}
      <Wrapper>
        {screens.xl && renderSearchCondition()}

        <StudentList
          isSelectCurrentPage={isSelectCurrentPage}
          isSelectAll={isSelectAll}
          columns={columns}
          showModal={showModal}
          rowSelection={rowSelection}
          handleSelectCurrentPage={handleSelectCurrentPage}
          handleDeselectAllRecords={handleDeselectAllRecords}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onPageChange={onPageChange}
          onPerPageItemChange={onPerPageItemChange}
          filterActions={filterActions}
          setFilterActions={setFilterActions}
          currentPageData={currentPageData}
          total={total}
          scrollAbleRef={scrollAbleRef}
        />
      </Wrapper>
    </Box>
  );
}

export default MessageDelivery;
